<hub-sub-menu></hub-sub-menu>
<ul class="meter-readings">
  <li>
    <span (click)="later()" class="created center">Newer</span>
    <span *ngIf="!this.hubID" class="hubid">HubID</span>
    <span class="reading">Reading</span>
    <span class="duration">Duration</span>
    <span class="kwhdelta">kWh</span>
    <span class="kwhperminute">kWh/minute</span>
  </li>

  <li *ngFor="let meter of readings" class="meter-reading">
    <span class="created">{{meter.created | godate}}</span>
    <span *ngIf="!this.hubID" class="hubid">{{meter.hubid}}</span>
    <ng-container *ngIf="!meter.saved_reading || meter.saved_reading <= 0; else reading" class="reading">
      <input type="text" [(ngModel)]="meter.reading" placeholder="reading" /><button (click)="save(meter)">Save</button>
    </ng-container>
    <ng-template #reading>
      <span class="reading">{{meter.reading}}</span>
      <span class="duration">{{meter.duration | humaninterval}}</span>
      <span class="kwhdelta">{{meter.kwhdelta}}</span>
      <span class="kwhperminute">{{meter.kwhperminute}}</span>
    </ng-template>
    <ng-container *ngIf="meter.has_image && meter.show_image; else noimage">
      <span *ngIf="meter.has_image" (click)="hideImage(meter)" class="created center">Hide Image</span>
    </ng-container>
    <ng-template #noimage>
      <span *ngIf="meter.has_image" (click)="showImage(meter)" class="created center">Show Image</span>
    </ng-template>
    <div *ngIf="meter.has_image && meter.show_image" class="image">
      <img src="/api/private/meters/images/{{meter.uid}}">
    </div>
  </li>

  <li>
    <span (click)="earlier()" class="created center">Older</span>
  </li>
</ul>
